import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { InteriorSlide } from './SlideShell';
import type { SlideProps } from './SlideShell';
const QUESTIONS = [{
  number: '01',
  question: 'What do you already have?',
  options: ['Campaign', 'Webinar', 'Website', 'Clinical content', 'Patient material']
}, {
  number: '02',
  question: 'Where could it work harder?',
  options: ['Attention', 'Engagement', 'Differentiation', 'Education', 'Follow-up']
}, {
  number: '03',
  question: 'Who are you trying to reach?',
  options: ['HCP', 'Patient', 'Rep', 'Congress delegate']
}] as const;
export function SlideInternalCTA({}: SlideProps) {
  return <InteriorSlide data-id="element-281" data-mp="1v6anv3w1c9qa">
      <motion.header initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="flex-shrink-0" data-id="element-282" data-mp="1v72b9rfhb15h">
        <p className="mb-2 text-[clamp(0.7rem,1vw,0.9rem)] font-bold uppercase tracking-[0.2em] text-[var(--brand)]" data-id="element-283" data-mp="3f8vo45y9erfr">
          Over to you
        </p>
        <h2 className="max-w-4xl text-[clamp(2rem,4vw,3.6rem)] font-extrabold leading-[1.02] tracking-[-0.04em] text-[var(--fg)]" data-id="element-284" data-mp="3ablra58jjdhw">
          What could we Snakify{' '}
          <span className="text-[var(--brand)]" data-id="element-285" data-mp="30cmp95ia6g3v">for your brand?</span>
        </h2>
      </motion.header>

      <div className="mt-[clamp(1rem,2vw,1.85rem)] grid min-h-0 flex-1 grid-cols-1 gap-[clamp(0.6rem,1.2vw,1.1rem)] md:grid-cols-3" data-id="element-286" data-mp="1t62fojhvihk">
        {QUESTIONS.map((item, index) => <motion.article key={item.question} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.18 + index * 0.1,
        duration: 0.45
      }} className="flex min-h-0 flex-col rounded-2xl bg-[var(--surface)] p-[clamp(1.15rem,2.2vw,2.15rem)]" data-id="element-287" data-mp="3o88ng5so5zmr" data-mpi={index}>
            <div className="min-w-0" data-id="element-288" data-mp="frdv3k9hzxmx">
              <span className="text-[clamp(0.72rem,1.05vw,0.98rem)] font-bold tracking-[0.2em] text-[var(--brand)]" data-id="element-289" data-mp="2a0ss298xn2hv">
                {item.number}
              </span>
              <h3 className="mt-[clamp(0.6rem,1.2vw,1.1rem)] text-[clamp(1.45rem,2.5vw,2.45rem)] font-extrabold leading-[1.06] tracking-[-0.04em] text-[var(--fg)]" data-id="element-290" data-mp="2f28di2f0vb0s">
                {item.question}
              </h3>
            </div>
            <ul className="mt-[clamp(0.75rem,1.4vw,1.25rem)] flex flex-wrap gap-[clamp(0.4rem,0.8vw,0.7rem)]" data-id="element-291" data-mp="1rabcl6d423eg">
              {item.options.map(option => <li key={option} className="rounded-full bg-white px-[clamp(0.75rem,1.35vw,1.25rem)] py-[clamp(0.4rem,0.75vw,0.65rem)] text-[clamp(0.92rem,1.3vw,1.25rem)] font-semibold text-[var(--fg)] ring-1 ring-[var(--fg)]/5" data-id="element-292" data-mp="1vabskvfuymnm">
                  {option}
                </li>)}
            </ul>
          </motion.article>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.55,
      duration: 0.5
    }} className="mt-[clamp(0.9rem,1.8vw,1.6rem)] flex flex-shrink-0 items-center gap-[clamp(0.9rem,1.8vw,1.75rem)] rounded-2xl bg-[var(--brand)] p-[clamp(1rem,1.9vw,1.75rem)]" data-id="element-293" data-mp="3gneutj3au4f5">
        <span className="flex h-[clamp(2.4rem,3.2vw,3.2rem)] w-[clamp(2.4rem,3.2vw,3.2rem)] flex-shrink-0 items-center justify-center rounded-full bg-white/15" data-id="element-294" data-mp="1a18rmc4gppl5">
          <ArrowRightIcon className="h-[clamp(1.1rem,1.5vw,1.5rem)] w-[clamp(1.1rem,1.5vw,1.5rem)] text-white" aria-hidden="true" data-id="element-295" data-mp="1nuqdw4oj9gev" />
        </span>
        <div className="min-w-0" data-id="element-296" data-mp="1xqbhg7992oqq">
          <p className="text-[clamp(1.15rem,2.2vw,2.1rem)] font-extrabold leading-tight tracking-[-0.03em] text-white" data-id="element-297" data-mp="1ss9rd2depp5r">
            Bring us one brand challenge.
          </p>
          <p className="mt-1 text-[clamp(0.85rem,1.25vw,1.15rem)] font-semibold text-[var(--brand-lighter)]" data-id="element-298" data-mp="3ewu1x3pp1e5">
            We’ll show you what a Snak campaign could look like.
          </p>
        </div>
      </motion.div>
    </InteriorSlide>;
}